import React from 'react'

import requests from './requests'
import './App.css';
import Row from './Row'

import Navbar from './Navbar';
import Banner from './Banner';
function App() {

  
  return (
    <div className="App">
       <Navbar/>
       <Banner fetchUrl={requests.fetchTreding}/>
      
     
     <Row title="Trending Now" fetchUrl={requests.fetchTreding}/>
     <Row title="Horror Movies" fetchUrl={requests.fetchHorroMovies}/>
     <Row title="Comedy Movies" fetchUrl={requests.fetchComedyMovies}/>
     <Row title="Action Movies" fetchUrl={requests.fetchActionMovies}/>
     
     <Row title="Documentries" fetchUrl={requests.fetchDocumentaries}/>
     <Row title="Romantic Movies" fetchUrl={requests.fetchRomanticMovies}/>
     
     <Row title="Netflix Originals" fetchUrl={requests.fetchNetFlixOriginals}/>
    
    </div>
  );
}

export default App;
